<!-- footer.component.html -->
<footer class="bg-white text-white pt-16 pb-8 px-4">
  <div class="max-w-7xl mx-auto">
    <!-- Main Footer Content -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">

      <!-- Brand Section -->
      <div class="lg:col-span-1">
        <div class="flex items-center mb-6">


          <img src="assets/img/Royal-International-logo.png" alt="Royal-International-logo" class="w-[200px] h-auto">

        </div>
        <p class="font-Playfair text-black mb-6 leading-relaxed">
          <span class="font-semibold">ROYAL INTERNATIONAL</span> beauty products help you look and feel younger. Using
          advanced nanotechnology, our chemists create effective, healthy, and eco-friendly skincare
        </p>

      </div>

      <!-- Quick Links -->
      <div>
        <h3 class="title-font-cinzel  text-lg font-semibold mb-6 text-pink-400">Quick Links</h3>
        <ul class="space-y-3">
          @for (link of quickLinks; track $index) {
          <li>
            <a [href]="link.path"
              class="text-black hover:text-pink-400 transition-colors duration-300 flex items-center group">
              <span
                class="w-2 h-2 bg-pink-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
              {{ link.name }}
            </a>
          </li>
          }
        </ul>
      </div>

      <!-- Contact Info -->
      <div>
        <h3 class="title-font-cinzel  text-lg font-semibold mb-6 text-pink-400">Get In Touch</h3>
        <div class="space-y-4">
          <div class="flex items-start space-x-3 group cursor-pointer">
            <div
              class="w-10 h-10 bg-pink-500/20 rounded-lg flex items-center justify-center mt-1 group-hover:bg-pink-500 transition-all duration-300">
              <i class="fas fa-envelope text-pink-500 group-hover:text-white"></i>
            </div>
            <div class="mt-2.5">
              <!-- <p class="title-font-cinzel  text-black text-sm">Email Us</p> -->
              <p class=" text-black group-hover:text-pink-400 transition-colors duration-300">info@royalbeautycream.com
              </p>
            </div>
          </div>

          <div class="flex items-start space-x-3 group cursor-pointer">
            <div
              class=" w-10 h-10 bg-pink-500/20 rounded-lg flex items-center justify-center mt-1 group-hover:bg-pink-500 transition-all duration-300">
              <i class="fas fa-phone text-pink-500 group-hover:text-white"></i>
            </div>
            <div class="mt-2.5">
              <!-- <p class="title-font-cinzel  text-black  text-sm">Call Us</p> -->
              <p class="text-black group-hover:text-pink-400 transition-colors duration-300"> 0092-336-9949494</p>
            </div>

          </div>
          <div class="flex items-start space-x-3 group cursor-pointer">
            <div
              class=" w-22 h-10 bg-pink-500/20 rounded-lg flex items-center justify-center mt-1 group-hover:bg-pink-500 transition-all duration-300">
              <i class="fas fa-map-marker-alt text-pink-500 group-hover:text-white"></i>
            </div>
            <div>
              <!-- <p class="title-font-cinzel  text-black  text-sm">Our Office</p> -->
              <p class="text-black group-hover:text-pink-400 transition-colors duration-300">Royal Plaza, 32 Commercial
                1st Floor, Canal View,
                Gujranwala, Pakistan.</p>
            </div>

          </div>
        </div>
      </div>

      <!-- Newsletter -->
      <div>
        <h3 class="title-font-cinzel  text-lg font-semibold mb-6 text-pink-400">Newsletter</h3>
        <p class="text-black mb-4">Subscribe to get updates on our latest products and offers.</p>
        <div class="flex flex-col space-y-3">
          <!-- <input type="email" placeholder="Enter your email"
            class="px-4 py-3  border border-gray-700 rounded-lg focus:outline-none focus:border-pink-500 transition-colors duration-300 text-white placeholder-gray-500"> -->
          <a  routerLink="/contact"
            class="px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg font-semibold hover:from-pink-600 hover:to-purple-700 transition-all duration-300 transform hover:-translate-y-0.5">
            Subscribe
        </a>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="pt-8 border-t border-gray-800">
      <div class="flex flex-col md:flex-row justify-center items-center space-y-4 md:space-y-0">
        <div class="text-black text-sm">
          © {{ currentYear }} Royal <small>(International)</small>. All rights reserved. | Powered by <span
            class="text-pink-400 font-semibold"> <a href="https://itdemons.com/">IT Demons</a></span> - Demons of
          Innovation

        </div>

      </div>

    </div>
  </div>
</footer>